// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__8CIfh","container":"styles_container__awyWW","toggleInteraction":"styles_toggleInteraction__lWOJq","icon":"styles_icon__9PKUl"};